var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 430,
    viewBox: "0 0 459 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_126)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.83 222.942L0.447561 7.11233L4.70427 2.41721L313.813 46.8241L455.058 311.532L450.677 316.364L169.83 222.942Z",
    fill: "url(#paint0_linear_103_126)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M455.057 311.532L314.332 47.7872L313.812 46.8238L313.777 46.8257L306.177 55.2086L306.995 55.8798L211.753 160.931L215.416 168.404L450.676 316.363L455.057 311.532Z",
    fill: "url(#paint1_linear_103_126)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.9,
    d: "M306.179 55.2034L313.779 46.8205L4.70415 2.41183L0.447441 7.10694L211.944 162.183L307.052 55.9205L306.179 55.2034Z",
    fill: "url(#paint2_linear_103_126)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.83 222.943L0.447425 7.11407L309.448 51.6404L450.656 316.318L169.83 222.943Z",
    fill: "url(#paint3_linear_103_126)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9,
    d: "M317.031 276.586C291.805 307.486 221.383 295.304 159.736 249.379C98.0891 203.454 68.5797 141.175 93.8094 110.308C119.039 79.4405 189.476 91.6057 251.105 137.516C312.733 183.425 342.261 245.719 317.031 276.586Z",
    fill: "url(#paint4_radial_103_126)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.325 311.433C280.886 318.535 220.846 289.145 156.451 239.744C92.0556 190.342 48.5207 138.706 53.9693 132.697C101.459 80.3164 115.999 35.6726 241.782 132.931C375.275 236.309 339.914 246.384 287.325 311.433Z",
    fill: "url(#paint5_linear_103_126)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.323 311.428C278.717 321.636 219.515 289.927 155.058 240.593C90.6007 191.26 45.3171 142.983 53.9046 132.76C62.4921 122.538 121.713 154.262 186.154 203.612C250.595 252.963 295.876 301.207 287.323 311.428Z",
    fill: "url(#paint6_radial_103_126)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    d: "M186.154 203.615C121.713 154.264 62.4769 122.557 53.9049 132.763C45.3329 142.968 90.601 191.262 155.058 240.595C219.515 289.929 278.717 321.638 287.323 311.43C295.929 301.223 250.673 252.88 186.154 203.615ZM158.008 237.091C150.044 231.001 142.222 224.789 134.713 218.625C75.5708 170.081 55.3971 140.628 57.746 135.677C63.5018 131.617 111.746 152.456 183.173 207.153C191.137 213.244 198.975 219.438 206.484 225.602C265.626 274.146 285.781 303.584 283.435 308.567C277.695 312.61 229.447 291.739 158.024 237.074L158.008 237.091Z",
    fill: "url(#paint7_linear_103_126)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M377.882 166.914C377.882 166.914 399.12 203.703 392.281 238.707C384.243 279.755 367.222 316.407 379.001 349.898C390.78 383.39 412.774 398.464 412.774 398.464L417.417 393.342C404.017 382.049 394.036 367.587 388.567 351.542C383.099 335.497 382.355 318.489 386.418 302.385C394.842 265.883 424.787 202.854 377.882 166.914Z",
    fill: "url(#paint8_radial_103_126)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M444.783 424.601C444.783 424.601 414.856 411.769 400.466 395.997C386.076 380.225 384.182 367.474 386.473 364.947C388.764 362.42 398.8 358.895 417.505 376.988C428.741 387.85 441.364 397.34 455.058 405.222C454.305 410.737 451.148 417.08 444.783 424.601Z",
    fill: "url(#paint9_radial_103_126)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M453.94 409.769C446.615 406.37 439.679 402.234 433.254 397.435C425.532 391.623 418.342 385.194 411.771 378.223C419.078 387.797 427.785 396.358 437.617 403.637C442.322 407.275 447.216 410.686 452.278 413.854C452.921 412.529 453.476 411.164 453.94 409.769Z",
    fill: "url(#paint10_radial_103_126)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M448.789 419.42C447.32 418.751 445.868 418.065 444.282 417.239C435.565 412.859 427.25 407.767 419.433 402.025C427.791 409.613 437.178 416.106 447.327 421.318C447.866 420.688 448.337 420.061 448.789 419.42Z",
    fill: "url(#paint11_radial_103_126)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_126",
    x1: 338.313,
    y1: -0.901759,
    x2: 175.488,
    y2: 254.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_126",
    x1: 439.106,
    y1: 83.0824,
    x2: 327.094,
    y2: 258.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_126",
    x1: 215.844,
    y1: -58.1619,
    x2: 106.292,
    y2: 113.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_103_126",
    x1: 333.44,
    y1: 5.40396,
    x2: 175.229,
    y2: 253.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_103_126",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(352.165 38.2032) rotate(39.3794) scale(127.387 81.2929)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#393434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#534F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#969494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_103_126",
    x1: 87.4158,
    y1: 94.6971,
    x2: 304.969,
    y2: 291.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_103_126",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.604 357.275) rotate(39.3794) scale(232.788 222.833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_103_126",
    x1: 57.2638,
    y1: 129.058,
    x2: 274.265,
    y2: 325.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_103_126",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(400.253 268.925) rotate(39.3794) scale(135.739 129.934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_103_126",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(441.297 378.769) rotate(-39.4796) scale(70.4416 72.2579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_103_126",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(433.908 387.668) rotate(39.3794) scale(67.064 64.1958)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_103_126",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.045 410.066) rotate(39.3794) scale(35.636 34.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 459,
    height: 430,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.67d08cce1a76c7a828c68cfbe79c78a8.svg";
export { ForwardRef as ReactComponent };